export default __webpack_public_path__ + "static/media/kitchen.87bdf9b4.webp";